/**
 * 常用联系人页面
 * 支持 A-Z 分组展示和普通列表展示
 */
import React from "react";
import CommonList from "./CommonList";
import AlphabetContactList from "./AlphabetContactList";
import type { IGroupedContacts } from "./AlphabetContactList";
import { IItemData } from "./common.typing";

export interface ICommonlyContactPageProps {
    /** 常用联系人（扁平列表） */
    commonlyList?: IItemData[];
    /** 常用联系人（A-Z 分组数据） */
    commonlyGrouped?: IGroupedContacts;
    currentList?: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    disabledids?: string[];
    requiredList?: IItemData[];
    multiple?: boolean;
}

function CommonlyContactPage(props: ICommonlyContactPageProps): React.ReactElement {
    const {
        commonlyList,
        commonlyGrouped,
        currentList = [],
        setCurrentList,
        disabledids,
        requiredList,
        multiple,
    } = props;

    // 有 A-Z 分组数据时使用分组展示
    if (commonlyGrouped && Object.keys(commonlyGrouped).length > 0) {
        return (
            <div className="myGroup alphabetView">
                <AlphabetContactList
                    groupedData={commonlyGrouped}
                    disabledids={disabledids}
                    currentList={currentList}
                    setCurrentList={setCurrentList}
                    requiredList={requiredList}
                    multiple={multiple}
                />
            </div>
        );
    }

    // 普通列表展示
    return (
        <div className="myGroup">
            <CommonList
                isShowOrg={true}
                onChangeCurPage={() => {}}
                track={() => {}}
                list={commonlyList}
                disabledids={disabledids}
                currentList={currentList}
                setCurrentList={setCurrentList}
                requiredList={requiredList}
                multiple={multiple}
            />
        </div>
    );
}

export default CommonlyContactPage;
